import React, {Component, useState} from 'react';
import { compose, withHandlers } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import FormHelperText from '@material-ui/core/FormHelperText';
import Typography from '@material-ui/core/Typography';
import { commonStyles } from '../../styles/styles';

import * as moment from 'moment';

import Select from 'react-select';
import { MDBDatePicker } from 'mdbreact';
import TextField from './TextField';
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from '@date-io/date-fns'; // choose your lib

import lightBlue from "@material-ui/core/colors/lightBlue";
import { createMuiTheme } from "@material-ui/core";
import { ThemeProvider } from "@material-ui/styles";

class renderDate extends Component {
  onChange = (event) => {
    
   if (this.props.input && event != null) {
   
    this.props.input.onChange(moment(event).format('YYYY-MM-DD'));
   } else {
    // 
    // this.props.input.onChange(null);
   }
  }
 
  render() {
    //const [selectedDate, handleDateChange] = useState(new Date());
   const { classes, meta, registrationForm, input, label, options, linkedData } = this.props;
   const conditionError = meta.error && meta.touched;
   var dateParts
   var jsDate ;
  //  <MDBDatePicker  disableFuture={true} openToYearSelection={true} getValue={this.onChange} valueDefault={null} theme={{
  //   palette: {
  //     primary: {
  //       main: '#dc3146',
  //     },
  //     secondary: {
  //       main: '#363636',
  //       contrastText: '#8E8E8E',
  //     },
  //   },
  //   typography: {
  //     useNextVariants: true,
  //   }
  // }}/>
   const materialTheme = createMuiTheme({
    palette: {
      primary: {
              main: '#dc3146',
            },
            secondary: {
              main: '#363636',
              contrastText: '#8E8E8E',
            },
    },

    overrides: {
     
      MuiPickersToolbar: {
        toolbar: {
          backgroundColor: '#dc3146',
        },
      },
      MuiPickersCalendarHeader: {
        switchHeader: {
          // backgroundColor: lightBlue.A200,
          // color: "white",
        },
      },
      MuiPickersDay: {
        day: {
          color: '#dc3146',
        },
        daySelected: {
          backgroundColor: '#dc3146',
        },
        dayDisabled: {
          color: '#dc3146',
        },
        current: {
          color: '#dc3146',
        },
      },
      MuiPickersModal: {
        dialogAction: {
          color: '#dc3146',
        },
      },
    },
  });
  
 // const dataToShow2 = linkedData.length > 0 ? linkedData : data;
 if(input.value!=""){
  dateParts= String(input.value).split("-");
  jsDate = new Date(input.value);
 }else{
  // jsDate = null
 }
 
  
   return (
    <FormControl
      
      aria-describedby="name-error-text"
      error={conditionError}
      style={{width:"100%", paddingTop:20, paddingBottom:20}}
    >
     <MuiPickersUtilsProvider utils={DateFnsUtils}>
      <ThemeProvider theme={materialTheme}>
        <DatePicker
           disableFuture
           openTo="year"
           format="dd/MM/yyyy"
            label="Date of Birth"
            value={jsDate}
            onChange={this.onChange}
            animateYearScrolling
          />
        </ThemeProvider>
      </MuiPickersUtilsProvider>
      {/* <DatePicker
       {...input}
       name={label}
      value={jsDate}
      onChange={this.onChange.bind(this)}
      format = 'y-MM-dd'
      onBlur={() => this.props.input.onBlur(jsDate)}
/> */}
      {conditionError && (
        <FormHelperText id="name-error-text" className={styles.errorBottomText}>
          {meta.error}
        </FormHelperText>
      )}
    </FormControl>
   );
  }
 }
 export default renderDate

const styles = () => ({
  ...commonStyles,
});
